import React from 'react'

function Studioz() {
  return (
    <div>
                {/* <!-- CONTENT START --> */}
        <div class="page-content">
        
           
             
            {/* <!-- SECTION CONTENTG START --> */}
            <div class="section-full p-tb80">  
                <div class="container">
                    <div class="section-content">
                    	<div class="page-notfound text-center">
                        	{/* <strong>Page Not Found</strong> */}
                            <img src="images/webimgs/BLACK - LA-TIERRA DESIGN STUDIO.png" alt="" width={300} />
                            <strong>We're launching our</strong>
                            <span class="title">new Website</span>
                            <p>Working hard for something we don't care about is called stress. <br /> Working hard for something we love is called passion.</p>
                            <a href="/" title="Back to home" class="site-button btn-effect">Back to home</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- SECTION CONTENT END --> */}
            
        </div>
        {/* <!-- CONTENT END --> */}
    </div>
  )
}

export default Studioz